module.exports = __webpack_public_path__ + "img/macbook with ss.facbe397.png";